module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bfYjUJ/tc-custom/9781680571066.jpg?1734031081996",
      "alt": "This image is the cover for the book Monsters, Movies & Mayhem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Monsters, Movies & Mayhem\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“A fun, nostalgia-filled anthology of twenty-three original, lighthearted horror tales riffing on the movie monsters of both modern cinema and B-movie favorites")]), _c('b', [_vm._v(".” —"), _c('i', [_vm._v("Publishers Weekly")])])]), _c('p', [_vm._v(" Lights! Camera! Monsters? ")]), _c('p', [_vm._v(" Sometimes you go to the movies. And sometimes, the movies—and their monsters—come to you. At any moment, without notice, monsters once relegated to the screen become a reality. Aliens and demons, dragons and ghosts, werewolves, vampires, zombies, and seemingly ordinary people who are just plain evil. ")]), _c('p', [_vm._v(" Join award-winning authors Jonathan Maberry, Fran Wilde, David Gerrold, Rick Wilber and others for twenty-three all-new tales of haunted theaters, video gods, formidable demons, alien pizza, and delirious actors. Each story takes you to the silver screen with monstrous results. ")]), _c('p', [_vm._v(" Funny or grim, unsettling or cozy . . . You’ll laugh! You’ll sigh! You’ll scream! ")]), _c('p', [_vm._v(" Grab popcorn—and good running shoes—and enjoy the show. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin J Anderson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WordFire Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0